
export class BankAccount {
  accountName :	string;
  accountNumber :	string;
  bankName : string;
  branchName :	string;
  swiftCode :	string;
}
